module.exports = __webpack_public_path__ + "img/kemenko.11f59776.png";